import { Component, OnInit, ViewChild } from '@angular/core';
import { CarouselComponent, OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-luminaries',
  templateUrl: './luminaries.component.html',
  styleUrls: ['./luminaries.component.scss']
})
export class LuminariesComponent implements OnInit {
  @ViewChild('owlCar') owlCar!: CarouselComponent;
  customOptions: OwlOptions = {
    loop: true,
    margin: 24,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: true,
    navSpeed: 600,
    autoplay: true,
    autoplayTimeout: 5000,
    autoplayHoverPause: true,
    responsive: {
      0: { items: 1 },
      576: { items: 1 },
      768: { items: 2 },
      1024: { items: 2 }
    },
    nav: false   // using custom external arrows
  }
  testimonial = [
    {
      id: 1,
      name: 'Justice C. Hari Shankar',
      position: 'High Court of Delhi',
      imgUrl: '/assets/img/testimonials/law1.png',
      degree: '',
      description: 'An enthusiastic group of persons – top of the art faculty and a warm atmosphere …'
    },
    {
      id: 2,
      name: 'Prof. (Dr.) Mahesh Verma',
      position: 'Vice Chancellor, GGSIPU',
      imgUrl: '/assets/img/testimonials/law2.png',
      degree: '',
      description: 'The Purpose and vision behind the whole project, undoubtedly is the promotion of academic, creative, cultural and other diversified activities undertaken by the College, which reflects the grand vision of its endeavours.'
    },
    {
      id: 3,
      name: 'Prof. K.K. Aggarwal',
      position: 'President, South Asian University (SAU)',
      imgUrl: '/assets/img/testimonials/law3.png',
      degree: '',
      description: 'We today require highly skilled but good natured teachers, legal experts, advisors, officers, counsellors etc. who can play a vital role in the overall growth of our nation and IIMT is a suitable place for such skills. This is very much clear that IIMT has always aggrandized the quality of teaching, learning & inculcating discipline along with culture.'
    },
    {
      id: 4,
      name: 'Prof. Dilip K. Bandyopadhyay',
      position: 'Former Vice Chancellor, GGSIPU',
      imgUrl: '/assets/img/testimonials/law4.png',
      degree: '',
      description: 'IIMT essentially showcase academic, creative, cultural and other diversified activities undertaken by the Institute. Students certainly benefit from this type of culture. It encourages the students to take part in diversified curricular and extracurricular activities for their overall development.'
    },
    {
      id: 5,
      name: 'Prof. Anil K. Tyagi',
      position: 'Former Vice Chancellor, GGS IPU',
      imgUrl: '/assets/img/testimonials/law5.png',
      degree: '',
      description: 'I am sure that the Institute will continue to scale new heights.'
    },
    {
      id: 6,
      name: 'Justice Iqbal Ahmed Ansari',
      position: 'Former Chief Justice, Patna High Court',
      imgUrl: '/assets/img/testimonials/law6.png',
      degree: '',
      description: 'The Management and Faculties are very warm persons and their exists professionalism …'
    },
    {
      id: 7,
      name: 'Prof. Thomas E. Nanny',
      position: 'University of Missouri Kansas City, USA',
      imgUrl: '/assets/img/testimonials/law7.png',
      degree: '',
      description: 'Wonderful Law School !!'
    },
    {
      id: 8,
      name: 'Jyotsna Yadav',
      position: 'Joint Director General, CCI',
      imgUrl: '/assets/img/testimonials/cover-pic-10.jpg',
      degree: '',
      description: 'The Faculty is very proactive and caring towards the students …'
    },
    {
      id: 9,
      name: 'Prof. Viney Kapoor Mehra',
      position: 'Founder V.C., DBRANLU, Sonepat, Haryana',
      imgUrl: '/assets/img/testimonials/cover-pic-10.jpg',
      degree: '',
      description: 'The staff and the Management are very cordial and have very pleasing attitude …'
    },
    {
      id: 10,
      name: 'Prof. R. K. Mittal',
      position: 'Hon’ble Vice Chancellor, Chaudhary Bansilal University, Bhiwani',
      imgUrl: '/assets/img/testimonials/law10.png',
      degree: '',
      description: 'Excellent Organization ...'
    },
    {
      id: 11,
      name: 'Dr. Amarendra Pani',
      position: 'Joint Director (Res), Association of Indian Universities',
      imgUrl: '/assets/img/testimonials/law11.png',
      degree: '',
      description: 'Ideal Institute is an organization leading towards excellence. Lively campus, talented students, very dynamic faculty with marvelous infrastructure …'
    },
    {
      id: 12,
      name: 'Prof. A. K. Koul',
      position: 'Former Vice Chancellor, NLU, Jodhpur & NLU, Ranchi',
      imgUrl: '/assets/img/testimonials/law12.png',
      degree: '',
      description: 'It is an excellent institution devoted to learning, research and personality building …'
    },
    {
      id: 13,
      name: 'Mr. Harjeet Singh Jaspal',
      position: 'Judge (Secretary, DLSA)',
      imgUrl: '/assets/img/testimonials/law13.png',
      degree: '',
      description: 'BEST WISHED TO FUTURE SENIOR ADVOCATE/JUDGES/JUSTICE OF INDIA AND THEIR TEACHERS FOR ALL THEIR GOOD EFFORTS.'
    },
    {
      id: 14,
      name: 'Prof. A.P. Singh',
      position: 'USLLS, GGS IP University',
      imgUrl: '/assets/img/testimonials/law14.png',
      degree: '',
      description: 'A WONDERFUL ACADEMIC AMBIENCE CREATED BY SHEER HARDWORK AND DEDICATION.'
    },
    {
      id: 15,
      name: 'Prof. Kanwal D.P. Singh',
      position: 'USLLS, GGSIPU',
      imgUrl: '/assets/img/testimonials/law15.png',
      degree: '',
      description: 'Extremely well organised Institution …'
    },
    {
      id: 16,
      name: 'Prof. Ritu Gupta',
      position: 'South Asian University (SAU)',
      imgUrl: '/assets/img/testimonials/law16.png',
      degree: '',
      description: 'EXCELLENT ORGANIZATION  AND THE DEDICATED TEAM.'
    },
    {
      id: 17,
      name: 'Prof. (Dr.) Sreejeth S.G.',
      position: 'Vice Dean, Jindal Global Law School, O.P. Jindal Global University',
      imgUrl: '/assets/img/testimonials/law17.png',
      degree: '',
      description: 'Amid extremely warm individuals. There is positivity permeating the place …'
    },
    {
      id: 18,
      name: 'Mr. Anand Prakash Mishra',
      position: 'Director (Law Admissions), O.P. Jindal Global University',
      imgUrl: '/assets/img/testimonials/law18.png',
      degree: '',
      description: '"WELL PLANNED AND ENCOURAGING INITIATIVE OF THE INSTITUTION IS BRING DIFFERENT COLLEGE AT A COMMON PLATEFORM IS EXHIBUTED AND DISPLAY SKILLS."'
    },
    {
      id: 19,
      name: 'Prof. Rajiv Khanna',
      position: 'SGT University, Gurugram',
      imgUrl: '/assets/img/testimonials/cover-pic-10.jpg',
      degree: '',
      description: 'GREAT INSTITUTE …'
    },
    {
      id: 20,
      name: 'Dr. Archana Sinha',
      position: 'Former AD&SJ, Delhi',
      imgUrl: '/assets/img/testimonials/cover-pic-10.jpg',
      degree: '',
      description: 'The Institution is VERY GOOD. The students in the Institute show that good education with personality development is impressed here.'
    },
    {
      id: 21,
      name: 'Mr. Anil K. Jain',
      position: 'Asstt. Registrar, High Court of Delhi',
      imgUrl: '/assets/img/testimonials/cover-pic-10.jpg',
      degree: '',
      description: 'I am happy the Institute is preparing the future citizens who are more than willing to DIG OUT THE TRUTH …'
    },
    {
      id: 22,
      name: 'Mr. Pranat Joshi',
      position: 'Secretary, DLSA Shahdara',
      imgUrl: '/assets/img/testimonials/cover-pic-10.jpg',
      degree: '',
      description: 'IIMT HAS ALWAYS WALKED IN HAND WITH DLSA IN FUTHERANCE OF ITS CAUSE OF CREATING LEGAL AWARENESS AND LITERARY PROGRAMMES.'
    },
    {
      id: 23,
      name: 'Mr. Arun Sharma',
      position: 'CEO, MINDWORKZZ',
      imgUrl: '/assets/img/testimonials/law23.png',
      degree: '',
      description: 'It was a pleasure to find such a dynamic and motivated set of teachers and students …'
    }
  ];
  prev() { this.owlCar.prev(); }
  next() { this.owlCar.next(); }

  constructor() { }
  ngOnInit(): void { }

}
